import { Segment } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite';
import PermitDashboardPermitHolderContent from './PermitDashboardPermitHolderContent';
import PermitDashboardShippingAddressContent from './PermitDashboardShippingAddressContent';
import PermitDashboardBillingAddressContent from './PermitDashboardBillingAddressContent';
import { useStore } from '../../../app/stores/store';

export default observer(function PermitDashboardSideContent() {
    const {userStore} = useStore();
    const {user} = userStore;

    return (
        <Segment basic>
            <PermitDashboardPermitHolderContent user={user!} />
            <PermitDashboardShippingAddressContent user={user!} />
            <PermitDashboardBillingAddressContent user={user!} />
            {/* <PermitDashboardWorkDestination /> */}
        </Segment>
    )
})